export const BRANDING_ENDPOINTS = {
  GET_BY_DOMAIN: (domain: string) => `/branding/public/get-by-domain?domain=${domain}`,
} as const; 